import { render, staticRenderFns } from "./RequirementsTable.vue?vue&type=template&id=214c67ef&scoped=true"
import script from "./RequirementsTable.vue?vue&type=script&lang=ts"
export * from "./RequirementsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214c67ef",
  null
  
)

export default component.exports